import { ERROR_ACTION, GET_MAIN_EXAM_ADVER, GET_POST_CRITERIA, GET_PRE_EXAM_ADVER, GET_STATISTICALDATA, SET_PRESENT_ABSENT_COUNTS} from "../../common/constants/ActionTypes";

const initialState = {
  
  statisticalReportData: {},
  // getstatisticaldata:[]
  getstatisticaldata:{},
  getPostCriteriaData:{}
};

export default function statisticalReportReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_PRESENT_ABSENT_COUNTS:
      return {
        ...state,
        statisticalReportData: action.payload,
      };
    case GET_STATISTICALDATA:
      return{
        ...state,
        getstatisticaldata:action.payload
      }
    case GET_POST_CRITERIA:
      return{
        ...state,
        getPostCriteriaData:action.payload
      }
      case GET_PRE_EXAM_ADVER:
        return{
          ...state,
          getpreexamAdvertbyYear:action.payload
        }
        case GET_MAIN_EXAM_ADVER:
          return{
            ...state,
            getmainExamAdvertbyYear:action.payload
          }
    default:
      return state;
  }
}
